import { authHeader, handleError } from '../helper';
import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";

export const tagAssignmentService = {
    // Tag CRUD operations
    getAllTags,
    searchTags,
    createOfficialTag,
    updateOfficialTag,
    deleteOfficialTag,

    // Tag assignment operations
    manageTagAssignments,
    assignTagsToUser,
    assignTagToUsers,
    getUserTags,
    getUserTagsList,
    searchUsersToAssignTag,
    removeTagFromUsers,
    addUpdateUserTags,
    getTagUserCount
};

/**
 * Gets all official tags
 * @returns {Promise} API response with all tags
 */
function getAllTags() {
    return APIHelper.get(APIURLConstants.GET_ALL_TAGS, authHeader())
        .then(data => {
            return data.data;
        })
        .catch(handleError);
}

/**
 * Searches for tags by name
 * @param {string} tagName - Tag name to search for (optional, empty string returns all)
 * @returns {Promise} API response with tag list
 */
function searchTags(tagName = '') {
    const postData = {
        tagName: tagName
    };

    return APIHelper.post(APIURLConstants.SEARCH_OFFICIAL_TAGS, postData, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Creates a new official tag
 * @param {Object} tagData - Tag data containing tagName
 * @returns {Promise} API response
 */
function createOfficialTag(tagData) {
    return APIHelper.post(APIURLConstants.CREATE_OFFICIAL_TAG, tagData, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Updates an existing official tag
 * @param {Object} tagData - Tag data containing id, tagName, isActive
 * @returns {Promise} API response
 */
function updateOfficialTag(tagData) {
    return APIHelper.post(APIURLConstants.UPDATE_OFFICIAL_TAG, tagData, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Deletes an official tag
 * @param {number} tagId - Tag ID to delete
 * @returns {Promise} API response
 */
function deleteOfficialTag(tagId, tagName) {
    const postData = {
        tagId: tagId,
        tagName: tagName
    };

    return APIHelper.post(APIURLConstants.DELETE_OFFICIAL_TAG, postData, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Manages bulk tag assignments - supports ASSIGN, REMOVE, and SYNC operations
 * @param {Array} assignments - Array of tag assignments
 * @param {string} assignmentMode - ASSIGN, REMOVE, or SYNC
 * @returns {Promise} API response
 */
function manageTagAssignments(assignments, assignmentMode) {
    const postData = {
        assignments: assignments,
        assignmentMode: assignmentMode
    };

    return APIHelper.post(APIURLConstants.MANAGE_TAG_ASSIGNMENTS, postData, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Assigns multiple tags to a single user
 * @param {Array} tagIDs - Array of tag IDs to assign
 * @param {string} officialUID - User's official UID
 * @returns {Promise} API response
 */
function assignTagsToUser(postData) {

    return APIHelper.post(APIURLConstants.ASSIGN_TAGS_TO_USER, postData, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Assigns a single tag to multiple users
 * @param {number} tagID - Tag ID to assign
 * @param {Array} officialUIDs - Array of user official UIDs
 * @returns {Promise} API response
 */
function assignTagToUsers(postData) {
       return APIHelper.post(APIURLConstants.ASSIGN_TAG_TO_USERS, postData, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Gets all tags assigned to a specific official
 * @param {string} officialUID - User's official UID
 * @returns {Promise} API response with user's tags
 */
function getUserTags(officialUID) {
    return APIHelper.get(APIURLConstants.GET_USER_TAGS(officialUID), authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

/**
 * Gets all tags for a user as a comma-separated string
 * @param {string} officialUID - User's official UID
 * @returns {Promise} API response with tag list as string
 */
function getUserTagsList(officialUID) {
    return APIHelper.get(APIURLConstants.GET_USER_TAGS_LIST(officialUID), authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

function searchUsersToAssignTag(data) {
    return APIHelper.post(APIURLConstants.SEARCH_USERS_TO_ASSIGN_TAG, data, authHeader())
        .then(data => {
            return data.data;
        })
        .catch(handleError);
}

function removeTagFromUsers(payload)
{
    return APIHelper.post(APIURLConstants.REMOVE_TAG_FROM_USERS, payload, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

function addUpdateUserTags(payload)
{
    return APIHelper.post(APIURLConstants.ADD_UPDATE_USER_TAGS, payload, authHeader())
        .then(data => {
            return data;
        })
        .catch(handleError);
}

function getTagUserCount()
{
    return APIHelper.get(APIURLConstants.GET_TAG_USER_COUNT, authHeader())
        .then(data => {
            return data.data;
        })
        .catch(handleError);
}
